import moment, { Moment } from 'moment-timezone';

import { PaymentDateOptionsDto } from '@alpha/payments-dtos';

const calculateDisablePaymentDates = (_date: Moment, dateOptions?: PaymentDateOptionsDto): boolean => {
  if (dateOptions) {
    const defaultTimezone = moment.tz.guess();

    const formattedDate = _date.tz(defaultTimezone)
      .format('YYYY-MM-DD');
    const todayDate = moment.tz('Europe/London').format('YYYY-MM-DD');

    const notHolidays = dateOptions.holidays.some((holiday) => moment(holiday.date).tz('Europe/London').format('YYYY-MM-DD') === formattedDate);
    _date.tz(defaultTimezone);

    return (
      moment(formattedDate).isBefore(todayDate)
      || moment(formattedDate).isBefore(dateOptions.earliestDate)
      || moment(formattedDate).isAfter(dateOptions.latestDate)
      || notHolidays
    );
  }
  return false;
};

export default calculateDisablePaymentDates;
